module.exports = __webpack_public_path__ + "static/media/tenantMobile.d3842cd3.svg";